import { lazy } from 'react';
import { Route } from './types';

const MessagesHistory = lazy(() => import('./pages/MessagesHistory'));
const MessagesTemplates = lazy(() => import('./pages/MessagesTemplates/MessagesTemplates'));

const MessageTemplatesCrud = lazy(() => import('./pages/MessageTemplatesCrud'));
const CompaniesPhones = lazy(() => import('./pages/CompaniesPhones'));
const CompaniesPhoneErrorsLogs = lazy(() => import('./pages/companiesPhones/CompanyPhoneErrorsLogs'));
const CompaniesMenuOptions = lazy(() => import('./pages/companiesPhones/MenuOptions'));
const Configurations = lazy(() => import('./pages/Configurations'));

const CompaniesWebhookErrorLogs = lazy(() => import('./pages/WebhookErrorLogs'));
const BusinessProfile = lazy(() => import('./pages/companiesPhones/BusinessProfile'));
const Users = lazy(() => import('./pages/Users'));
const UsersInvites = lazy(() => import('./pages/UsersInvites'));

const routes: Route[] = [
    {
        path: 'messages_templates',
        title: 'Messages templates',
        placeholder: 'table',
        element: MessageTemplatesCrud,
        children: [
            {
                path: ':waba_id',
                title: 'Manage Templates',
                placeholder: 'table',
                element: MessagesTemplates,
            },
            {
                path: ':id/waba/:waba_id',
                title: 'Manage Templates',
                placeholder: 'table',
                element: MessagesTemplates,
            },
        ],
    },
    {
        path: 'messages_history',
        title: 'Messages History',
        element: MessagesHistory,
    },
    {
        path: 'phones',
        title: 'Phones',
        placeholder: 'table',
        element: CompaniesPhones,
        children: [
            {
                path: ':phone_id/error_logs',
                title: 'Error logs',
                placeholder: 'table',
                element: CompaniesPhoneErrorsLogs,
            },

            {
                path: ':phone_id/menu_options',
                title: 'Menu Options',
                placeholder: 'table',
                element: CompaniesMenuOptions,
            },
            {
                path: ':phone_id/profile',
                title: 'Business profile',
                placeholder: 'table',
                element: BusinessProfile,
            },
        ],
    },
    {
        path: 'configurations',
        title: 'Configurations',
        placeholder: 'table',
        element: Configurations,
    },
    {
        path: 'webhook_error_logs',
        title: 'Webhook error logs',
        placeholder: 'table',
        element: CompaniesWebhookErrorLogs,
    },
    {
        path: 'users',
        title: 'Users',
        placeholder: 'table',
        element: Users,
        children: [
            {
                path: 'invites',
                title: 'Users invites',
                placeholder: 'table',
                element: UsersInvites,
            },
        ],
    },
];

export default routes;
